import { styled } from '@mui/material/styles';
import SwitchBase from 'components/Switch';
export const Switch = styled(SwitchBase)`
  justify-content: space-between;
  margin: 0;
`;
